import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useModal } from "src/recoil/modalState/hook";
import qs from "qs";
import { useMemo } from "react";

/** 탭 공통 처리 */
export const useHandleTab = () => {
  const pathVariables = useParams();

  const { setBaseModal } = useModal();

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
        allowDots: true,
        decoder: (value) => value,
      }),
    [location.search],
  );

  const handleTabClick = (tab: { value: string; label: string }) => {
    if (!pathVariables.id && !queryParams.id) {
      return setBaseModal({ isOpen: true, btnRightTitle: "확인", title: "기본정보가 저장되지 않았습니다" });
    }

    const { list } = queryParams || {}

    // query parameter 에 tab 추가
    const newQueryParamStr = qs.stringify({ tab: tab.value, id: queryParams.id || pathVariables.id, ...(!!list && { list }) }, { allowDots: true });
    navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
  };

  return { handleTabClick };
};
